// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgLevelEmpty = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      d="M2.166 12.668a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4.667a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z"
    />
    <rect
      width={4}
      height={10.667}
      x={8}
      y={7.168}
      stroke="currentColor"
      rx={0.5}
    />
    <rect
      width={4}
      height={15.667}
      x={13.834}
      y={2.168}
      stroke="currentColor"
      rx={0.5}
    />
  </svg>
);
export const LevelEmptyIcon = forwardRef(SvgLevelEmpty);
